<template>
  <a-modal
    class="modal-container"
    :title="title"
    :width="650"
    :visible="visible"
    ok-text="保存"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <template>
      <a-form-model ref="ruleForm" :model="form" :rules="rules">
        <a-form-model-item label="状态">
          <a-date-picker v-model="form.date" placeholder="请选择状态" style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item label="请描述学生好转的具体情况">
          <a-textarea
            v-model="form.evalWay"
            :auto-size="{ minRows: 5, maxRows: 8 }"
            placeholder="请输入内容"
          />
        </a-form-model-item>
      </a-form-model>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: 'CreateEvaluation',
  props: {
    title: {
      type: String,
      default: '效果反馈',
    },
  },
  data() {
    return {
      visible: false,
      current: 1,
      form: {},
      rules: {
        // name: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        // dateRang: [{ required: true, message: '请选择日期范围', trigger: 'blur' }],
        // radius: [{ required: true, message: '请选择测评范围', trigger: 'blur' }],
        // evalWay: [{ required: true, message: '请选择测评方式', trigger: 'blur' }],
      },
      currEvalInfo: {},
      gradeOptions: [
        {
          label: '一年级',
          value: '1',
        },
        {
          label: '二年级',
          value: '2',
        },
      ],
      classOptions: [
        {
          label: '一班',
          value: '1',
        },
        {
          label: '二班',
          value: '2',
        },
      ],
      evalWayOptions: [
        { label: '学校机房', value: '1' },
        { label: '自主测评', value: '2' },
      ],
    }
  },
  methods: {
    showModal(data, index) {
      this.form = { oldName: data.name, name: data.name }
      this.currEvalInfo = data
      console.log('数据：', data)
      this.visible = true
    },
    hideModal() {
      this.visible = false
      this.current = 1
    },
    handleOk() {
      if (this.current == 1) {
        this.$refs.ruleForm.validate((valid) => {
          if (!valid) return
          this.current = 2
        })
        return
      }
      console.log('表单验证通过：', this.form)
      this.hideModal()
    },
    handleCancel() {
      this.hideModal()
    },
  },
}
</script>
<style scoped lang="less">
.modal-container {
  /deep/ .ant-modal-body {
    padding: 10px 24px 24px 24px;
  }
  /deep/ .ant-form-item {
    margin-bottom: 0px;
  }
}
</style>
